module.exports = __webpack_public_path__ + "img/ico_man.dc124132.png";